

export const headerData = {
    name: 'Subhashni Jha',
    title: "Hello! I am",
    desciption: "Hello, I'm subhashni jha, a full stack software developer with a passion for coding and problem-solving. I thrive in dynamic environments, dedicated to continuous learning. My goal is to leverage technology for innovative solutions and contribute to the world of software development.",
    image: 'https://ibb.co/1ZptZfq',
    imagebw: './Assets/subhashni-bw.jpg', 
    resumePdf: 'https://example.com/subhashni-resume.pdf', 
};
